module.exports = __webpack_public_path__ + "static/img/20240426_1.06742fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240426_1.png
// module id = aM/k
// module chunks = 0